import { useMemo } from "react"
import { GrupoDescuento, TipoDescuento, useGetDescuentosQuery } from "src/gql/schema"
import { div, times } from "src/shared/helpers/calculator"
import { useProfile } from "src/shared/hooks/useProfile"
import { FilterDescuentos } from "../ModalDescuentos.type"
import { getCurrencyFormat } from "src/utils/string"
import { formatDate, isDateRangeExpired } from "../utils/date"

export function useOpcionesDescuentos(params?: FilterDescuentos) {
    const { zona_horaria } = useProfile()
    const { hotel_id } = useProfile()
    const default_params: FilterDescuentos = {
        type: "renta",
        total: 0,
        ...(params || {}),
    }

    const { data, loading } = useGetDescuentosQuery({
        variables: {
            fecha_inicio: default_params?.fecha_fin
                ? { before: formatDate(default_params.fecha_fin, +(params?.fin_offset || 1)) }
                : null,
            fecha_fin: default_params?.fecha_inicio
                ? { after: formatDate(default_params.fecha_inicio, -(params?.inicio_offset || 1)) }
                : null,
            sin_vigencia: default_params?.sin_vigencia ?? true,
            tipo_habitacion_ids: default_params?.tipo_habitacion_ids || null,
            hotel_id,
            grupo_descuento: default_params?.grupo_descuento as GrupoDescuento || null,
            uso_unico: default_params?.uso_unico !== undefined ? default_params?.uso_unico  : null
        }
    })

    
    const { type } = default_params

    const options = useMemo(() => {
        if (type === "room_service") {
            return []
        }

        return data?.descuentos?.filter((f)=>
            f.condiciones?.[type || "renta"] && 
            !isDateRangeExpired(f.fecha_fin, zona_horaria) &&
            !(default_params?.unique_discount_ids?.includes(f.descuento_id) && f.uso_unico)
        ).map((d)=>{
            const isPercent = d?.tipo_descuento === TipoDescuento.Porcentaje
            const valor = Number(d?.valor || 0)
            const calcTotal = isPercent ? times(div(valor || 1, 100), Number(params?.total || 1)) : d?.valor
            
            return {
                label: `${d?.nombre} | -${isPercent ? `${valor}%` : getCurrencyFormat(valor)}`, value: d?.descuento_id, total: calcTotal, tipo_descuento: d?.tipo_descuento, valor
            }
        }) || []
    }, [data?.descuentos])

    return {
        opciones_descuentos: options,
        loading,
    }
}